import {Typography} from 'antd';
import {AccountFieldsFragment} from 'api/generated';
import {Ellipsize, Favicon} from 'components';
import React from 'react';
import {Helmet} from 'react-helmet';
import styled from 'styled-components';

type Props = {
  account?: AccountFieldsFragment | null;
};

const Title = styled(Typography.Title)`
  position: relative;
  display: flex;
  overflow: hidden;
  margin: 0;
  align-items: center;
`;

export const AccountTitle: React.FC<Props> = ({account}) => {
  if (!account) return null;

  const accountName =
    account.name || account.business?.companyName || account.business?.legalName || '';

  return (
    <Title>
      <Helmet title={accountName} />
      <Favicon account={account} style={{marginRight: 15, minWidth: 32}} shape="square" />
      <Ellipsize>{accountName}</Ellipsize>
    </Title>
  );
};
